import { store } from '../../../../../../../resources/frontend/js/store';
import { maskInput } from '@leads.io/mask-utils';

import TelephoneLibphonenumberMask from './general-masks/telephone-libphonenumber-mask';
import MobileLibphonenumberMask from './general-masks/mobile-libphonenumber-mask';
import IbanMask from './general-masks/iban-mask';
import NumericMask from './general-masks/numeric-mask';
import SmscodeMask from './general-masks/smscode-mask';

import arMask from './countries-masks/ar.js';
import atMask from './countries-masks/at.js';
import auMask from './countries-masks/au.js';
import beMask from './countries-masks/be.js';
import brMask from './countries-masks/br.js';
import caMask from './countries-masks/ca.js';
import chMask from './countries-masks/ch.js';
import clMask from './countries-masks/cl.js';
import coMask from './countries-masks/co.js';
import crMask from './countries-masks/cr.js';
import czMask from './countries-masks/cz.js';
import deMask from './countries-masks/de.js';
import dkMask from './countries-masks/dk.js';
import ecMask from './countries-masks/ec.js';
import esMask from './countries-masks/es.js';
import fiMask from './countries-masks/fi.js';
import frMask from './countries-masks/fr.js';
import gbMask from './countries-masks/gb.js';
import grMask from './countries-masks/gr.js';
import gtMask from './countries-masks/gt.js';
import hkMask from './countries-masks/hk.js';
import huMask from './countries-masks/hu.js';
import idMask from './countries-masks/id.js';
import ieMask from './countries-masks/ie.js';
import ilMask from './countries-masks/il.js';
import inMask from './countries-masks/in.js';
import itMask from './countries-masks/it.js';
import jpMask from './countries-masks/jp.js';
import krMask from './countries-masks/kr.js';
import ltMask from './countries-masks/lt.js';
import luMask from './countries-masks/lu.js';
import mxMask from './countries-masks/mx.js';
import myMask from './countries-masks/my.js';
import nlMask from './countries-masks/nl.js';
import noMask from './countries-masks/no.js';
import nzMask from './countries-masks/nz.js';
import peMask from './countries-masks/pe.js';
import phMask from './countries-masks/ph.js';
import plMask from './countries-masks/pl.js';
import ptMask from './countries-masks/pt.js';
import roMask from './countries-masks/ro.js';
import seMask from './countries-masks/se.js';
import sgMask from './countries-masks/sg.js';
import svMask from './countries-masks/sv.js';
import thMask from './countries-masks/th.js';
import trMask from './countries-masks/tr.js';
import twMask from './countries-masks/tw.js';
import usMask from './countries-masks/us.js';
import vnMask from './countries-masks/vn.js';
import zaMask from './countries-masks/za.js';

export const setCountryMask = () => {
    let countryFile = '';

    switch (store.state.page.countryCode) {
        case 'ar':
            countryFile = arMask;
            break;

        case 'at':
            countryFile = atMask;
            break;

        case 'au':
            countryFile = auMask;
            break;

        case 'be':
            countryFile = beMask;
            break;

        case 'br':
            countryFile = brMask;
            break;

        case 'ca':
            countryFile = caMask;
            break;

        case 'ch':
            countryFile = chMask;
            break;

        case 'cl':
            countryFile = clMask;
            break;

        case 'co':
            countryFile = coMask;
            break;

        case 'cr':
            countryFile = crMask;
            break;

        case 'cz':
            countryFile = czMask;
            break;

        case 'de':
            countryFile = deMask;
            break;

        case 'dk':
            countryFile = dkMask;
            break;

        case 'ec':
            countryFile = ecMask;
            break;

        case 'es':
            countryFile = esMask;
            break;

        case 'fi':
            countryFile = fiMask;
            break;

        case 'fr':
            countryFile = frMask;
            break;

        case 'gb':
            countryFile = gbMask;
            break;

        case 'gr':
            countryFile = grMask;
            break;

        case 'gt':
            countryFile = gtMask;
            break;

        case 'hk':
            countryFile = hkMask;
            break;

        case 'hu':
            countryFile = huMask;
            break;

        case 'id':
            countryFile = idMask;
            break;

        case 'ie':
            countryFile = ieMask;
            break;

        case 'il':
            countryFile = ilMask;
            break;

        case 'in':
            countryFile = inMask;
            break;

        case 'it':
            countryFile = itMask;
            break;

        case 'jp':
            countryFile = jpMask;
            break;

        case 'kr':
            countryFile = krMask;
            break;

        case 'lt':
            countryFile = ltMask;
            break;

        case 'lu':
            countryFile = luMask;
            break;

        case 'mx':
            countryFile = mxMask;
            break;

        case 'my':
            countryFile = myMask;
            break;

        case 'nl':
            countryFile = nlMask;
            break;

        case 'no':
            countryFile = noMask;
            break;

        case 'nz':
            countryFile = nzMask;
            break;

        case 'pe':
            countryFile = peMask;
            break;

        case 'ph':
            countryFile = phMask;
            break;

        case 'pl':
            countryFile = plMask;
            break;

        case 'pt':
            countryFile = ptMask;
            break;

        case 'ro':
            countryFile = roMask;
            break;

        case 'se':
            countryFile = seMask;
            break;

        case 'sg':
            countryFile = sgMask;
            break;

        case 'sv':
            countryFile = svMask;
            break;

        case 'th':
            countryFile = thMask;
            break;

        case 'tr':
            countryFile = trMask;
            break;

        case 'tw':
            countryFile = twMask;
            break;

        case 'us':
            countryFile = usMask;
            break;

        case 'vn':
            countryFile = vnMask;
            break;

        case 'za':
            countryFile = zaMask;
            break;
    }

    store.commit('form/setAttribute', { key: 'countryMask', value: new countryFile() });
};

export const getMask = (type, field, name) => {
    let mask;
    const countryMask = store.state.form.attributes.countryMask;
    const value = field.value;
    const valueSpaceless = value.replace(/[^a-zA-Z0-9+]/g, '');

    if (type === 'quiz') {
        mask = store.getters['quiz/getExtraData']('mask', name);
    }

    if (type === 'form') {
        mask = store.getters['form/getFieldData']('mask', name);
    }

    switch (mask) {
        case 'telephoneLibphonenumber':
            return new TelephoneLibphonenumberMask().telephone(valueSpaceless, store.state.page.countryCode);

        case 'telephoneLibphonenumberWithoutTrailingZero':
            return new TelephoneLibphonenumberMask().telephone(valueSpaceless, store.state.page.countryCode, true);

        case 'mobileLibphonenumber':
            return new MobileLibphonenumberMask().telephone(valueSpaceless, store.state.page.countryCode);

        case 'zipcode':
            return countryMask.zipcode(value);

        case 'birthdate':
            return countryMask.birthdate();

        case 'birthYear':
            return new NumericMask().numeric(countryMask.decimalSeparator, 4);

        case 'iban': // bankaccount
            return new IbanMask().iban(value);

        case 'numeric':
            return new NumericMask().numeric(countryMask.decimalSeparator);

        case 'smscode':
            return new SmscodeMask().smscode();
    }
};

export const useMask = (type, field, name) => {
    let mask = getMask(type, field, name);
    let maskType;
    let isTel = false;
    let value = field.value;

    if (type === 'quiz') {
        maskType = store.getters['quiz/getExtraData']('mask', name);
    }

    if (type === 'form') {
        maskType = store.getters['form/getFieldData']('mask', name);
    }

    if (store.state.page.useNewMask) {
        if (maskType === 'telephoneLibphonenumber' || maskType === 'telephoneLibphonenumberWithoutTrailingZero') {
            mask = mask.replaceAll('9', '#');
        }

        const masked = maskInput(mask, field);

        if (!masked) {
            return field.value;
        }

        return masked.value;
    }

    if (!maskType) return value;

    if (maskType === 'telephoneLibphonenumber' || maskType === 'telephoneLibphonenumberWithoutTrailingZero') {
        isTel = true;
    }

    let correctValue = value.replace(/[^a-zA-Z0-9+\uFF10-\uFF19]/g, '');

    let cursorPosition = field.selectionStart;

    let regex = '^';
    let spaces = [];

    /**
     * The characters in the masks have a meaning, here we define those
     */
    const maskMeaning = {
        'a': '[a-zA-Z]',
        '9': '[0-9+]',
        '0': '0',
        '1': '[0-1]',
        '2': '[0-2]',
        '3': '[0-3]',
        '*': '[0-9a-zA-Z]',
        'J': '[0-9\uFF10-\uFF19]',
        ' ': '\\s',
        '-': '-',
    };

    /**
     * This function checks if a mask or a regex was provided.
     * If it was provided a regex, it skips all other checks.
     */
    if (mask.match(/^\//)) {
        mask = mask.replace(/^\/+|\/+$/g, '');

        let regexExp = new RegExp(mask);
        const length = value.length - 1;

        if (!value.match(regexExp)) {
            value = value.slice(0, length);
        }

        return value;
    }

    /**
     * This function determines the position of the spaces and other defined special characters
     * and pushes them to an array, later to be used
     */
    for (let i = 0; i < mask.length; i++) {
        let char = mask.charAt(i);

        if (char === ' ' || char === '-') {
            spaces.push([i, char]);
        }
    }

    /**
     * The spaces and special characters are now added to the value to their designated positions
     */
    for (let j = 0; j < spaces.length; j++) {
        const position = spaces[j][0];
        const character = spaces[j][1];

        correctValue = correctValue.slice(0, position) + character + correctValue.slice(position);
    }

    correctValue = correctValue.replace(/^-+|-+$/g, '');
    correctValue = correctValue.trim();
    value = correctValue;

    /**
     * Here we check every character on a match - if it doesn't match it breaks and slices the last character
     *
     * Timeout: for some reason the special characters are sometimes ignored without this timeout
     *
     * UpdateInputType: update the input type based on the next character from the mask when a correct character was entered,
     * to prevent changing the input type too early
     */
    for (let i = 0; i < value.length; i++) {
        let char = mask.charAt(i);

        const reg = maskMeaning[char];
        regex += reg;

        let regexExp = new RegExp(regex);

        if (!value.match(regexExp)) {
            value = value.slice(0, i);
            return value;
        }
    }

    // Remove spaces and dashes from mask and value
    const maskTrimmed = mask.replace(/-|\s/g, '');
    const fieldValueTrimmed = value.replace(/-|\s/g, '');

    // Get the next character from the mask that would follow after the current character in the input
    // If there is no next character, which is the case when a full zipcode is pasted / auto-filled, get the character that came before it
    let nextMaskCharacter = maskTrimmed.charAt(fieldValueTrimmed.length) || maskTrimmed.charAt(fieldValueTrimmed.length - 1);

    // When the next mask character is a number, change input type to tel, else change to text
    if (parseInt(nextMaskCharacter) || nextMaskCharacter === 'J' || nextMaskCharacter === '') {
        field.type = 'tel';
        field.inputMode = isTel ? 'tel' : 'numeric';
    } else {
        field.type = 'text';
        field.inputMode = 'text';
    }

    /**
     * Because the value is currently being reset, the cursos loses it position,
     * with this function we prevent that, putting it back to it's original position
     */
    field.selectionStart = cursorPosition;

    if (field.selectionStart !== field.selectionEnd) {
        field.selectionStart = cursorPosition + 1;
        field.selectionEnd = cursorPosition + 1;
    }

    return value;
};
